import React from 'react';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import Navbar from '../../components/navbarOut';
import Footer from '../../components/footer';
import { Form, Input, Button, message, Card } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import './iniciarSesion.css';

/**
 * Componente principal para gestionar el inicio de sesión.
 * @component
 */
const IniciarSesion = () => {
  const eyeRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);

  /**
   * Maneja el movimiento del mouse para la animación del icono del ojo.
   * @param {Event} event - Evento de movimiento del mouse.
   */
  const handleMouseMove = (event) => {
    if (eyeRef.current) {
      const { left, top, width, height } = eyeRef.current.getBoundingClientRect();
      const eyeCenterX = left + width / 2;
      const eyeCenterY = top + height / 2;
      const angleDeg = angle(eyeCenterX, eyeCenterY, event.clientX, event.clientY);
      eyeRef.current.style.transform = `rotate(${angleDeg}deg)`;
    }
  };

  /**
   * Calcula el ángulo entre dos puntos.
   * @param {number} cx - Coordenada X del centro.
   * @param {number} cy - Coordenada Y del centro.
   * @param {number} ex - Coordenada X del punto externo.
   * @param {number} ey - Coordenada Y del punto externo.
   * @returns {number} - Ángulo en grados.
   */
  const angle = (cx, cy, ex, ey) => {
    const dy = ey - cy;
    const dx = ex - cx;
    const rad = Math.atan2(dy, dx); // range (-PI, PI]
    const deg = rad * (180 / Math.PI); // rads to degs, range (-180, 180]
    return deg;
  };

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  /**
   * Cambia la visibilidad de la contraseña.
   */
  const togglePasswordVisibility = () => {
    // Esta función cambia la visibilidad de la contraseña y actualiza la clase para la animación.
    setIsPasswordVisible(prevState => !prevState);
  };


  const cardStyle = {
    borderRadius: '20px',
    overflow: 'hidden',
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.8)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    padding: '40px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  };

  const buttonStyle = {
    width: '100%',
    height: '50px',
    fontSize: '16px',
    fontWeight: '600',
    background: 'linear-gradient(135deg, #639aff 0%, #5468ff 100%)',
    border: 'none',
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(99, 154, 255, 0.3)',
    marginTop: '20px'
  };

  const inputStyle = {
    height: '50px',
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    border: '2px solid #e8ecef',
    color: '#2c3e50',
    fontSize: '15px'
  };

  /**
   * Maneja el envío del formulario de inicio de sesión.
   * @param {Object} values - Valores del formulario.
   */
  const handleSubmit = async (values) => {
    try {
      const usuarioData = {
        email: values.email,
        password: values.password,
      };
      //https://api.99envios.app/api/auth/login      http://127.0.0.1:8000/api/auth/login
      const response = await axios.post('https://api.99envios.app/api/auth/login', usuarioData);
      const now = new Date();
      const expirationTime = new Date(now.getTime() + 6 * 3600 * 1000);

      localStorage.setItem('token', response.data.token);  // Almacenar el token en el almacenamiento local}
      
      localStorage.setItem('usuario_id', response.data.user.id);  // Almacenar el ID del usuario en el almacenamiento local
      localStorage.setItem('rol_id', response.data.user.id_rol);  // Almacenar el ID del rol en el almacenamiento local
      localStorage.setItem('email', response.data.user.email);  // Almacenar el correo electrónico en el almacenamiento local
      
      if (!response.data.sucursales === 0) {
        console.log(response.data.sucursales[0].nombre); // Esto debería imprimir "usuario de prueba"
        localStorage.setItem('nombre', response.data.sucursales[0].nombre);
        console.log(localStorage.getItem('nombre')); // Esto debería imprimir "usuario de prueba"
    }
     // localStorage.setItem('nombre', response.data.sucursales[0].nombre);
      



      localStorage.setItem('expiration', expirationTime.getTime().toString());
      message.success(`Inicio de sesión exitoso para ${values.email}!`);

      console.log('Inicio de sesión exitoso:', response);
      console.log('Datos de usuario:', response.data.user.id_rol);
      if (response.data.user.id_rol === 1) {
        navigate('/admin');
      } else if (response.data.user.id_rol === 2) {
        navigate('/conductor');
      } else if (response.data.user.id_rol === 3) {
        navigate('/tablero ');
      } else if (response.data.user.id_rol === 4) {
        navigate('/conductor');
      }
    } catch (error) {
      message.error('Error al iniciar sesión. Por favor, verifica tus credenciales.');
      console.error('Error al iniciar sesión:', error);
    }
  };






  return (
    <div className="login-container-login-ultima-milla">
      <Navbar />
      <div className="content-wrapper-login-ultima-milla">
        <div className="login-sides-container-login-ultima-milla centered">
          <div className="tab-izquierda-login-ultima-milla">
            <div className="card-content">
              <h3>Únete como Repartidor</h3>
              <p>Forma parte de nuestra red y comienza a generar ingresos de manera flexible</p>
              <a href="/crear/repartidor" className="btn-registro-login-ultima-milla">
                <span>Comenzar ahora</span>
                <i className="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>

          <div className="formularioL-login-ultima-milla">
            <Card style={cardStyle} className="ant-card-login-ultima-milla">
              <div className="login-header-login-ultima-milla">
                <h2>¡Bienvenido!</h2>
                <p>Inicia sesión para continuar</p>
              </div>
              <Form
                form={form}
                name="registro"
                onFinish={handleSubmit}
                layout="vertical"
                className="ant-form-login-ultima-milla"
              >
                <Form.Item
                  label={<span className="input-label-login-ultima-milla">Correo electrónico</span>}
                  name="email"
                  rules={[
                    { 
                      required: true, 
                      message: 'Por favor ingresa tu correo!' 
                    },
                    {
                      type: 'email',
                      message: 'Ingresa un correo válido!'
                    }
                  ]}
                  className="ant-form-item-login-ultima-milla"
                >
                  <Input 
                    prefix={<i className="fas fa-envelope input-icon-login-ultima-milla"></i>}
                    placeholder="Ingresa tu correo" 
                    className="ant-input-login-ultima-milla styled-input-login-ultima-milla custom-input-ultima-milla"
                    style={inputStyle}
                  />
                </Form.Item>

                <Form.Item
                  label={<span className="input-label-login-ultima-milla">Contraseña</span>}
                  name="password"
                  rules={[{ required: true, message: 'Por favor ingresa tu contraseña!' }]}
                  className="ant-form-item-login-ultima-milla"
                >
                  <Input.Password
                    prefix={<i className="fas fa-lock input-icon-login-ultima-milla"></i>}
                    placeholder="Ingresa tu contraseña"
                    className="ant-input-login-ultima-milla styled-input-login-ultima-milla custom-input-ultima-milla"
                    style={inputStyle}
                    iconRender={(visible) => (
                      <div className="eye-icon-login-ultima-milla" ref={eyeRef}>
                        {visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
                      </div>
                    )}
                  />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" style={buttonStyle} className="ant-btn-primary-login-ultima-milla submit-button-login-ultima-milla">
                    Iniciar Sesión
                  </Button>
                </Form.Item>

                <div className="login-footer-login-ultima-milla">
                  <a href="https://api.99envios.app/formulario-recuperar-contrasenia" className="forgot-password-login-ultima-milla">
                    ¿Olvidaste tu contraseña?
                  </a>
                </div>
              </Form>
            </Card>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default IniciarSesion;